module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('block', {
    attrs: {
      "id": "experience",
      "title": "Expérience professionnelle"
    }
  }, [_c('timeline', [_vm._l((_vm.experiences), function(experience) {
    return [_c('timeline-title', [_vm._v(_vm._s(experience.title))]), _vm._v(" "), _vm._l((experience.items), function(experienceItem) {
      return _c('timeline-item', [_c('b', [_vm._v(_vm._s(experienceItem.date))]), _vm._v(" - "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(experienceItem.title)
        }
      }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((experienceItem.skills), function(skill) {
        return [_c('chips', [_vm._v(_vm._s(skill))])]
      })], 2)
    })]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17359538"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Experience.vue
// module id = 290
// module chunks = 1